/* eslint-disable @typescript-eslint/semi */
import { Component } from '@angular/core';
import { baseUrl, FIREBASE_CONFIG } from 'src/environments/environment';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics'
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private http: HttpClient
  ) {

    console.log(baseUrl)
    this.http.get(baseUrl).subscribe((res) => {
      console.log(res)
    })


    firebase.initializeApp(FIREBASE_CONFIG);

  }
}
